/* Find web addresses in ordinary prose.
 *
 * The intro tells somebody to go to hub.intermountainhs.com, and printing an
 * address people have to retype is the same as not telling them.
 *
 * PURE, AND DELIBERATELY NOT JSX. It returns plain parts - strings and
 * `{ href, text }` objects - so the matching can be unit-tested by `node --test`
 * with no DOM and no build step, and so the caller renders its own elements.
 * That also means no HTML is ever produced here: the component turns a part
 * into an <a> and React escapes the text, which is what keeps a pasted
 * sentence from carrying markup into the page.
 *
 * NARROW ON PURPOSE. A host with at least two labels and a known ending. A
 * looser pattern links "e.g." and "No. 5", which looks broken in exactly the
 * place the form is trying to sound trustworthy.
 */
const URL_RE = /\b((?:https?:\/\/)?(?:[a-z0-9-]+\.)+(?:com|org|net|gov|edu|io)(?:\/[^\s,;)]*)?)/gi;

/** `"go to hub.x.com now"` -> `['go to ', {href, text}, ' now']` */
export function splitLinks(text) {
  const s = String(text ?? '');
  const parts = [];
  let last = 0;

  for (const m of s.matchAll(URL_RE)) {
    // A trailing full stop belongs to the sentence, not to the address.
    const raw = m[1].replace(/[.]+$/, '');
    if (m.index > last) parts.push(s.slice(last, m.index));
    parts.push({
      text: raw,
      href: /^https?:\/\//i.test(raw) ? raw : `https://${raw}`,
    });
    last = m.index + raw.length;
  }

  if (last < s.length) parts.push(s.slice(last));
  return parts;
}

export { URL_RE };
